import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Login } from '../login/login.component';
import { Main } from '../main/main.component';
import { Home } from '../home/home.component';
import { Business } from '../business/business.component';
import { Products } from '../products/products.component';
import { NotFound } from '../not-found/not-found.component';
import { Sales } from '../sales/sales.component';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/login' element={<Login/>}/>
        <Route path='/' element={<Main/>}>
          <Route index element={<Home/>}/>
          <Route path='/business/:id' element={<Business/>}/>
          <Route path='/products' element={<Products/>}/>
          <Route path='/sales' element={<Sales/>}/>
        </Route>
        <Route path='*' element={<NotFound/>} />
      </Routes>
    </BrowserRouter>
  );
}
